import React from 'react'
import '../App.css'

const Adminheader = () => {
  return (
    <div className="text-center p-3 admin-heder">
        <h1>BSK ADMIN PANEL</h1>
    </div>
  )
}

export default Adminheader